import TooltipBadge from 'components/TooltipBadge/TooltipBadge'
import { Button } from 'react-bootstrap'
import Translation from 'assets/default/translation.json'
import Urls from 'assets/default/url.json'
import Modal from '../Modal'
import s from './VousNeTrouvezPasVotreResultat.module.scss'

interface Props {
  show: boolean
  onHide: () => void
}

const VousNeTrouvezPasVotreResultat = ({
  show,
  onHide,
}: Props): JSX.Element => (
  <Modal
    show={show}
    onCloseButtonClick={onHide}
    additionalModalClassNames={s.vousNeTrouvezPasVotreResultat}
    title="Vous ne trouvez pas votre résultat ?"
    body={
      <>
        <p>Lisez attentivement ce qui suit :</p>
        <ol>
          <li>
            <p>
              Vous êtes-vous correctement formé(e) à l’utilisation de{' '}
              {Translation.common.produit}?
            </p>
            <p>
              Si ce n’est pas déjà fait, regardez attentivement le tutoriel
              eLearning et participez au webinar de formation :
            </p>
            <div className={s.elearningWebinar}>
              {Urls.videos.geolocaliseUnBien && (
                <div className={s.elearning}>
                  <p>
                    eLearning : « Géolocaliser un bien avec{' '}
                    {Translation.common.produit} »
                  </p>
                  <Button href={Urls.videos.geolocaliseUnBien} target="_blank">
                    Voir le tutoriel
                  </Button>
                </div>
              )}
              {typeof Urls.pagesOmega.formation === 'string' && (
                <div className={s.webinar}>
                  <p>
                    Webinar : « Présentation de {Translation.common.produit} »
                  </p>
                  <Button href={Urls.pagesOmega.formation} target="_blank">
                    M’inscrire au webinar
                  </Button>
                </div>
              )}
            </div>
          </li>
          <li>
            <p>Avez-vous saisi les bons critères de recherche ?</p>
            <ol>
              <li>
                <p>
                  Retournez sur votre formulaire de recherche en cliquant sur le
                  bouton « Modifier » en haut à gauche de votre écran.
                </p>
              </li>
              <li>
                <p>
                  Vérifiez les critères saisis en vous aidant des espaces
                  d’information (marqués par un&nbsp;
                  <TooltipBadge label="" />) présents à côté de chaque champ.
                </p>
              </li>
              <li>
                <p>
                  {/* TODO: ADD Tooltip example */}
                  Vous avez un doute ? Augmentez l’emprise au sol et/ou la
                  surface du terrain : vous obtiendrez ainsi plus de résultats
                  et ferez le tri en fonction de leur aspect.
                </p>
              </li>
            </ol>
            <p>
              Faites des essais ! C’est par la pratique qu’on devient expert J
            </p>
          </li>
          <li>
            <p>Vous n’avez toujours pas trouvé ?</p>
            <p>
              Ça arrive ! Certains biens sont très difficiles à géolocaliser,
              pour diverses raisons :
            </p>
            <ul>
              <li>
                Les critères saisis ne concordent pas avec les données du
                cadastre et de DVF : terrain composé de plusieurs parcelles,
                extension ou piscine non déclarée, …
              </li>
              <li>
                Les informations disponibles ne sont pas suffisantes pour vous
                permettre de faire une recherche pertinente
              </li>
            </ul>
            <p>
              {Translation.common.produit} est comme Meetic : on n’a pas la
              garantie de dénicher la pépite ! Retentez avec une autre annonce
              😉
            </p>
            <p>
              Et souvenez-vous : la valeur sûre pour trouver des mandats reste
              le terrain !
            </p>
          </li>
        </ol>
        <Button onClick={onHide}>J&apos;ai compris !</Button>
      </>
    }
  />
)

export default VousNeTrouvezPasVotreResultat
